import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { PoBreadcrumb, PoDialogService, PoModalComponent, PoNotificationService, PoSelectOption, PoTableAction, PoTableColumn } from '@po-ui/ng-components';
import { RomaneioService } from '../../romaneio/service/romaneio.service';
import { defaultFiltroUR, defaultUR, FiltroUR, UR } from '../../romaneio/interface/romaneio';


@Component({
  selector: 'app-ur-lista',
  templateUrl: './ur-lista.component.html',
  styleUrl: './ur-lista.component.css'
})
export class UrListaComponent implements OnInit {

  public readonly poTableActions: Array<PoTableAction>;

  tabelaPrincipalItens: Array<UR> = [];
  tabelaPrincipalFiltro: FiltroUR = defaultFiltroUR();

  dadosUR: UR = defaultUR();

  inclui: boolean = false;

  public readonly poTableColumns: Array<PoTableColumn>;

  breadcrumb: PoBreadcrumb = {
    items: [
      {label: 'Home', action: this.goHome.bind(this)}
    ],
  };

  @ViewChild('modalIncluirUR', { static: true }) modalIncluirUR!: PoModalComponent;

  constructor(
    private router: Router,
    private romaneioService: RomaneioService,
    private poNotificationService: PoNotificationService,
    private poDialogService: PoDialogService,
  ){

    this.poTableColumns = [
      { property: 'CZ05COD'     , label: 'Código' , width: '15%' },
      { property: 'CZ05UR'      , label: 'UR'     , width: '15%' },
      { property: 'NZ05VOLUME'  , label: 'Volume' , width: '15%'  , type: 'number', format: '1.4-4' },
      { property: 'NZ05SALDO'   , label: 'Saldo'  , width: '15%'  , type: 'number', format: '2.8-8' },
      { property: 'CZ05TIPO'    , label: 'Tipo'   , width: '15%'  , type: 'subtitle',
        subtitles: [
          { value: '1'  , label: 'Rústico'        , color: 'color-01' , content: 'RT' },
          { value: '2'  , label: 'Remanufatura'   , color: 'color-08' , content: 'RE' },
        ]
      },
      { property: 'CZ05BLOQ'    , label: 'Status' , type: 'label',
        labels: [
          { value: 'N', color: 'color-10', label: 'Habilitado'  },
          { value: 'S', color: 'color-07', label: 'Bloqueado'   },
        ]
      },
      { property: 'actions' , label: ' ' , width: '10%', type: 'icon',
        icons:[
          { value: 'editar'   , tooltip:'Editar'  , icon: 'po-icon-edit'    , action: this.actionEditar.bind(this) },
          { value: 'excluir'  , tooltip:'Excluir' , icon: 'po-icon-delete'  , action: this.actionExcluir.bind(this) },
        ]
      },
    ];

    this.poTableActions = [
      { label: 'Editar'  , icon: 'po-icon-edit'   , action: this.actionEditar.bind(this) },
      { label: 'Excluir' , icon: 'po-icon-delete' , action: this.actionExcluir.bind(this) },
    ];

  }

  ngOnInit(): void {
  };

  buscaRegistros(): void {
    this.tabelaPrincipalItens = []
    this.romaneioService.getURLista(this.tabelaPrincipalFiltro).subscribe((ret) => {
      this.tabelaPrincipalItens = ret.items
    })
  };

  postUR(incluir: boolean, dados: UR): void {
    if(incluir){
      this.dadosUR = defaultUR()
      this.inclui = true
    } else {
      this.dadosUR = dados
      this.inclui = false
    }
    this.modalIncluirUR.open()
  };

  salvarUR(): void {
    this.romaneioService.postUR(this.dadosUR).subscribe({
      next: (ret) => {
        this.poNotificationService.success(`Registro ${ret.retorno} com sucesso! Código ${ret.CZ05COD}`);
        this.dadosUR = defaultUR();
        this.modalIncluirUR.close();
        this.buscaRegistros();
      },
      error: () => {
        this.poNotificationService.error('Falha no processo. Tente novamente ou informe a TI.');
      }
    });
  };

  cancelarUR(): void {
    this.dadosUR = defaultUR();
    this.modalIncluirUR.close();
  };

  actionEditar(row: UR): void {
    this.postUR(false, row)
  };

  actionExcluir(dados: UR): void {
    this.poDialogService.confirm({title:'Excluir UR', message:`Deseja realmente excluir esse registro? Código ${dados.CZ05COD}`,
      confirm: () =>{
        this.romaneioService.deleteUR(dados.NZ05RECNO).subscribe((ret) => {
          this.poNotificationService.success('Registro excluído com sucesso!');
          this.buscaRegistros();
        })
      }
    })
  };

  alteraValorVolume(): void {
    if(this.inclui){
      this.dadosUR.NZ05SALDO = this.dadosUR.NZ05VOLUME;
    }
  };

  goHome(): void {
    this.router.navigateByUrl('');
  };

}
